import { useNavigate, useParams } from 'react-router';
import { useAnalysisQuery } from '../api/queries/analysis';
import { useErrorToast } from '../lib/useErrorToast';
import { AnalysisValues } from '../components/analysis-value/analysis-values';
import { Button } from '@convergence/components';
import { useLaunchAnalysisMutation } from '../api/queries/launchAnalysis';
import { StatusIndicator } from '../components/StatusIndicator';
import { AnalysisValueProps } from '../components/analysis-value/types';
import { useCancelAnalysisMutation } from '../api/queries/cancelAnalysis';
import { AnalysisNext } from '../components/AnalysisNext';

export function Analysis() {
  const params = useParams();
  const navigate = useNavigate();
  if (!params.slug) {
    navigate('/');
    return null;
  }
  const slug = params.slug;
  console.log({ slug });
  const analysisQuery = useAnalysisQuery(slug);

  const launchAnalysisMutation = useLaunchAnalysisMutation();
  const cancelAnalysisMutation = useCancelAnalysisMutation();

  useErrorToast(analysisQuery.error);

  const status = analysisQuery.data?.status ?? 'PENDING';

  const inputs = analysisQuery.data?.input;
  const outputs = analysisQuery.data?.output;

  if (analysisQuery.isLoading) {
    return (
      <div className="h-full flex items-center justify-center">Loading...</div>
    );
  }

  return (
    <div className="h-full overflow-scroll p-8">
      <header className="flex items-center justify-between border-b border-black py-4">
        <div className="flex items-center gap-1">
          <StatusIndicator
            status={status}
            statuses={{
              PENDING: {
                color: '#ffc107',
                pulse: true
              },
              COMPLETED: {
                color: '#28a745'
              },
              FAILED: {
                color: '#dc3545'
              },
              CANCELLED: {
                color: '#dc3545'
              }
            }}
          />
          {status === 'CANCELLED' && ` (Cancelled)`}
          <h1 className="text-xl font-terminal">
            {analysisQuery.data?.name ?? ''}
          </h1>
        </div>
        {status === 'PENDING' ? (
          <Button
            onClick={() => {
              if (!analysisQuery.data) return;
              cancelAnalysisMutation.mutate({
                analysisId: analysisQuery.data.id
              });
            }}
          >
            Cancel
          </Button>
        ) : (
          <Button
            onClick={() => {
              if (!analysisQuery.data) return;
              launchAnalysisMutation.mutate({
                analysisId: analysisQuery.data.id,
                analysisSlug: analysisQuery.data.slug
              });
            }}
          >
            Relaunch
          </Button>
        )}
      </header>
      {inputs && (
        <AnalysisValues values={inputs as AnalysisValueProps['value']} />
      )}
      {outputs ? (
        <AnalysisValues values={outputs as AnalysisValueProps['value']} />
      ) : (
        <div>Outputs not available yet</div>
      )}
      <AnalysisNext slug={slug} />
    </div>
  );
}
